import React, {useEffect, useRef, useState, useContext} from 'react';
import {getConstraints, initDevice, reportEvent, useEffectOnce} from '../../../../utils';
import {Stream} from "../helpers/Stream";
import {EVENT_TRACER} from "../../../../constants";
import { ConfigContext } from '../../../../context/ConfigContext';

const COLOR_SUCCESS = '#ACFFB7'
const TIMEMOUT = 30
export const MAX_RESOLUTION_HEIGHT = 800
export function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
let CONFIG
let timer
export default function useLiveness({setShowFlash, imgResult, videoResult, containerRef, guideAdoRef, videoRef, setAlertVisible, imgBack, scanLine, textMessages, containerTextMessages, containerGuideAdo}) {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    const { value: configValue } = useContext(ConfigContext);
    const codeTransaction = params.codeTransaction
    const urlServiceLiveness = params.urlServiceLiveness;
    const showError = params.showError || 'false'
    const debug = params.debug || false
    const attempts = params.attempts || 1
    const isMovil = params.isMovil || false
    const platform = params.platform || 'web'
    const projectName = params.projectName || 'default'
    const language = params.language || 'es'
    const emitReadyCam = params.emitReadyCam || 'false'
    const activeFlash = params.activeFlash || 'false'
    const urlTracer = params.urlTracer
    const processId = params.processId
    const [seconds, setSeconds] = useState(0);
    const [errorMessage, setErrorMessage] = useState('')
    const [flashOn, setFlashOn] = useState(false);

    const canvasRef = useRef(null);
    const config = useRef(null);
    const firstRecorder = useRef(true)
    const counterTimeout = useRef(0)
    const renderUI = useRef(false)

    const [messagesLiveness, setMessagesLiveness] = useState('')
    const [finished, setFinished] = useState(false)
    const [loading, setLoading] = useState(true)
    const [loadingMetaData, setLoadingMetaData] = useState(false)
    const [showcheck, setShowCheck] = useState(false)
    const [showMessage, setShowMessage] = useState(true)

    function setDisplayElement(element, display) {
        if (element) element.style.display = display
    }

    async function onReportEvent(eventType, message = '') {
        if (!urlTracer) return
        try {
            await reportEvent(urlTracer, processId, eventType, message)
        } catch (e) {
            console.log('error report event', e.message)
        }
    }

    function formatMessageError(error) {
        const errorsMessages = {
            FACE_ANGLE_TOO_LARGE: "Mira directamente a la cámara",
            FACE_CLOSE_TO_BORDER: 'Centra tu cara dentro del circulo',
            FACE_NOT_FOUND: "¡No te vemos! Ubica tu cara dentro del circulo",
            FACE_TOO_SMALL: "Acerca un poco más tu rostro",
            PROBABILITY_TOO_SMALL: "Acerca un poco más tu rostro",
            TOO_MANY_FACES: "Solo debe haber un rostro en el recuadro. ¡El tuyo!",
            FACE_TOO_CLOSE: 'Estás muy cerca, aléjate un poco',
            FACE_CROPPED: 'Ubica tu cara dentro del circulo',
            FACE_IS_OCCLUDED: 'No te vemos bien, quita el objeto que tapa tu cara',
            EYES_CLOSED: 'Abre los ojos',
            GENERAL_ERROR: 'Quedate quieto y mira a la cámara',
            POOR_LIGHTING: 'Por favor, ubícate en un lugar con buena iluminación',
            FACE_HORIZONTAL_MISALIGNMENT: 'Centra tu rostro y mira directo a la cámara',
            FACE_VERTICAL_MISALIGNMENT: 'Centra tu rostro y mira directo a la cámara',
            FACE_ROTATION_MISALIGNMENT: 'Centra tu rostro y mira directo a la cámara',
            BLURRY_IMAGE: 'Quedate quieto y mira a la cámara',
            FACE_NEVER_DETECTED: 'No pudimos detectar tu rostro',
        };
        const errorMessageKey = errorsMessages[error] || 'DEFAULT_ERROR';
        const messageSource = language === 'es'
        ? config?.current?.messages
        : config?.current?.messagesEnglish;
        setMessagesLiveness(errorsMessages[error]);
    }

    function changeUIToFinished() {
        containerRef.current.classList.add('success')
        setShowCheck(true)
    }

    const callbackErrors = (error, isError) => {
    }


    const DEFAULT_WIDTH = 1200;
const DEFAULT_HEIGHT = 700;
const QUALITY = 0.9;
const RESIZE_DELAY = 500;
const RESPONSE_DELAY = 1000;

async function callbackAutoCapturing(images, response) {
    try {
        await prepareForProcessing();
        const videoRecorded = await recordingVideo();
        setLanguageSpecificEndMessage();
        setLoading(true)
        const { newWidth, newHeight } = calculateDimensions();
        await processImages(images, newWidth, newHeight, videoRecorded, response);
    } catch (error) {
        console.error("Error in callbackAutoCapturing:", error);
    }
}

async function prepareForProcessing() {
    const streamRef = Stream.getInstance();
    streamRef.dropStream();
    setLoadingMetaData(true);
    onReportEvent(EVENT_TRACER.LIVENESS.LivenessCaptureSuccess, 'El liveness detecto rostro').catch();
    clearInterval(timer);
}

function setLanguageSpecificEndMessage() {
    const endMessage = language === 'es' ? config?.current?.messages?.END_TEXT || 'Espera un momento' : config?.current?.messagesEnglish?.END_TEXT || 'Wait a moment';
    setMessagesLiveness(endMessage);
}

function calculateDimensions() {
    if (isMobile()) {
        return { newWidth: videoRef.current.videoWidth, newHeight: videoRef.current.videoHeight };
    }
    return { newWidth: DEFAULT_WIDTH, newHeight: DEFAULT_HEIGHT };
}

async function processImages(images, newWidth, newHeight, videoRecorded, result) {
    setTimeout(async () => {
        // const imageResized = await resizeBase64(isMobile() ? images.original : images.cropped, newWidth, newHeight, QUALITY);
        setLoading(false);
        changeUIToFinished();
        const resultToHost = createResultToHost(result, videoRecorded, images.original, images.cropped);
        setTimeout(() => finalizeProcessing(JSON.stringify(result), resultToHost), RESPONSE_DELAY);
    }, RESIZE_DELAY);
}

function createResultToHost(result, videoRecorded, imageResized, croppedImage) {

    const formattedResult = {
        success: result.Success,
        keyBucketImage: result.KeyBucketImage,
        keyBucketVideo: result.KeyBucketVideo,
        data: {
            score: projectName.toLowerCase().includes("colsubsidio") ? 0.6 : 0.1,
            quality: result.data.quality,
            isAlive: result.data.isAlive,
            isFraud: result.data.isFraud,
            probability: result.data.probability,
            threshold_probabillity: result.data.threshold_probabillity,
            threshold_quality: result.data.threshold_quality,
        }
    }
    console.log("formattedResult", formattedResult)
    return {
        ...formattedResult,
        videoBase64: '',
        photoBase64: imageResized,
        videoBlob: {}
    };
}

function finalizeProcessing(result, resultToHost) {
    console.log('finalizeProcessing', result, resultToHost);
    onReportEvent(EVENT_TRACER.LIVENESS.LivenessResponseToHost, result).catch();
    responseToHost(resultToHost);
}


    async function startCamera(cameraType) {
        if (!videoRef.current) return
        try {
            const constraints = getConstraints(initDevice().isMac, cameraType);
            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            videoRef.current.srcObject = stream;
            setFinished(true);
            setTimeout(() => initializeCameraSettings(), 3000);
        } catch (error) {
            console.log('Error al inicializar la camara:', error);
            if (error.message === 'Device in use') {
                setErrorMessage('La camara está en uso, por favor cierra las aplicaciones que la estén utilizando')
                setAlertVisible(true)
            }
            onReportEvent(EVENT_TRACER.LIVENESS.LivenessCameraError, error.message).catch();
            finalizeProcessing("Error al acceder a la camara", 'Error al acceder a la cámara:')
        }
    }

    function initializeCameraSettings() {
        setLanguageSpecificMessage();
        onReportEvent(EVENT_TRACER.LIVENESS.LivenessCameraOpen, 'Camara del liveness iniciada').catch();
        const { rectangleWidth, rectangleHeight } = calculateRectangleDimensions();
        configUI(rectangleWidth, rectangleHeight);
        const streamRef = initializeStreamRef();
        streamRef.updateHtmlElements(videoRef.current, canvasRef.current);
        setupStreamRefCallbacks(streamRef);
        setLoading(false);
        initTimer();
        startDetection(streamRef);
    }

    function setLanguageSpecificMessage() {
        const message = language === 'es'
        ? config?.current?.messages?.INIT_TEXT || 'Ubica el rostro en el círculo'
        : config?.current?.messagesEnglish?.INIT_TEXT || 'Place the face in the circle';
        setMessagesLiveness(message);
    }

    function showScreenElements() {
        if(containerRef.current)
        containerRef.current.classList.replace('hide-elements', 'display-elements');
    }

    function hideScreenElements() {
        if(containerRef.current)
        containerRef.current.classList.replace('display-elements', 'hide-elements');
    }

    function calculateRectangleDimensions() {
        const video = videoRef.current;
        const minDimension = Math.min(video.videoWidth, video.videoHeight);
        const screenHeight = window.screen.height;
        const rectangleWidth = isMobile() ? minDimension * 0.53 : screenHeight <= MAX_RESOLUTION_HEIGHT ? minDimension * 0.48 : minDimension * 0.63;
        const rectangleHeight = isMobile() ? minDimension * 0.63 : screenHeight <= MAX_RESOLUTION_HEIGHT ? minDimension * 0.58 : minDimension * 0.73;
        return { rectangleWidth, rectangleHeight };
    }

    function deviceType() {
        const ua = navigator.userAgent;

        if (/iP(hone|od|ad)/.test(ua)) {
            return "IOS";
        }
    
        if (/android/i.test(ua)) {
            return "ANDROID";
        }
    
        if (/Win|Mac|Linux|X11/.test(ua)) {
            return "DESKTOP";
        }
    
        return "UNKNOWN";
    }
    
    function initializeStreamRef() {
        return Stream.getInstance(initDevice(), '/models', false, {
            processId: codeTransaction,
            codeTransaction,
            deviceType: deviceType(),
            urlServiceLiveness,
        });
    }

    function setupStreamRefCallbacks(streamRef) {
        streamRef.setFaceDetection(true);
        streamRef.setCallbackAutoCapturing(callbackAutoCapturing);
        streamRef.setCallbackErrors(callbackErrors);
        streamRef.setCallbackFaceDetectionErrors(callbackFaceDetectionError);
    }

    function callbackFaceDetectionError(e) {
        const streamRef = Stream.getInstance(initDevice())
        formatMessageError(e);

        // send timeout response to host
        if (e === 'FACE_NEVER_DETECTED') {
            onReportEvent(EVENT_TRACER.LIVENESS.LivenessTimeout, 'El liveness entró en timeout').catch()
            onReportEvent(EVENT_TRACER.LIVENESS.LivenessResponseToHost, 'Se excedió el tiempo para la captura').catch()
            streamRef.dropStream()
            setTimeout(() => {
                responseToHost('Se excedió el tiempo para la captura', 'timeout')
            }, 4000);
        }
    }

    async function startDetection(streamRef) {
        await streamRef.startDetection();
        responseToHostReadyCam();
    }



    function initTimer() {
        timer = setInterval(() => {
            counterTimeout.current = counterTimeout.current + 1
            setSeconds(prevSeconds => prevSeconds + 1);
        }, 1000);
    }
    function stopCamera() {
        try {
            const stream = videoRef.current.srcObject;
            if (stream) {
                const tracks = stream.getTracks();
                tracks.forEach(track => track.stop());
            }
            videoRef.current.srcObject = null;
        } catch (e) {
            console.log('error stopCamera', e)
        }
    }
    function getDeviceType() {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "tablet";
        }
        if (
            /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
                ua
            )
        ) {
            return "mobile";
        }
        return "desktop";
    }
    function blobToBase64(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function() {
                const base64data = reader.result;
                resolve(base64data);
            };
            reader.onerror = function(error) {
                reject(error);
            };
        });
    }
    function recordingVideo() {
        onReportEvent(EVENT_TRACER.LIVENESS.LivenessInitCaptureVideo, 'El liveness inició grabación').catch()
        const codecsToCheck = [
            // WebM Video
            'video/webm; codecs=vp8',
            'video/webm; codecs=vp9',
            'video/webm; codecs=vp10',
            'video/webm; codecs=h264',
            'video/webm; codecs="vp8, opus"',
            'video/webm; codecs="vp9, opus"',
            'video/webm; codecs="vp8, vorbis"',
            'video/webm; codecs="vp9, vorbis"',

            // MP4 Video
            'video/mp4; codecs=avc1.42E01E',
            'video/mp4; codecs=avc1.58A01E',
            'video/mp4; codecs=avc1.4D401E',
            'video/mp4; codecs=avc1.64001E',
            'video/mp4; codecs=hevc',
            'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
            'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
            'video/mp4; codecs="avc1.64001E, mp4a.40.2"',
            'video/mp4',

            // OGG Video
            'video/ogg; codecs=theora',
            'video/ogg; codecs="theora, vorbis"',
            'video/ogg; codecs="theora, opus"',

            // AV1 Video
            'video/av1',
            'video/av1; codecs="av01"',

            // VPx Video
            'video/vp8',
            'video/vp9',

            // Others
            'video/3gpp',
            'video/3gpp; codecs="mp4v.20.8, samr"',
            'video/h265',

            // Matroska Video
            'video/x-matroska; codecs=avc1',
            'video/x-matroska; codecs="avc1, opus"',
            'video/x-matroska; codecs="avc1, vorbis"',

            // MPEG TS Video
            'video/mp2t',
            'video/mp2t; codecs="avc1.42E01E, mp4a.40.2"',
            'video/mp2t; codecs="avc1.4D401E, mp4a.40.2"',

            // Misc
            'video/quicktime',
            'video/mpeg',
        ];
        return new Promise(async (resolve, reject) => {
            try {
                const stream = videoRef.current.srcObject
                let mediaRecorder;
                let codecSelected = 'video/mp4'

                for (const codec of codecsToCheck) {
                    if (MediaRecorder.isTypeSupported(codec)) {
                        if (firstRecorder.current) {
                            codecSelected = codec
                            mediaRecorder = new MediaRecorder(stream, { mimeType: codec });
                            firstRecorder.current = false
                            break
                        }
                    }
                }

                mediaRecorder.start(1000);  // disparará ondataavailable cada segundo

                let chunks = [];
                mediaRecorder.ondataavailable = (event) => {
                    if (event.data.size > 0) {
                        chunks.push(event.data);
                    }
                };
                mediaRecorder.onstart = () => {
                    setTimeout(() => {
                        mediaRecorder.stop();
                    }, 2000);
                };
                mediaRecorder.onerror = (event) => {
                    console.log('MediaRecorder error state:', mediaRecorder.state);
                    console.error('MediaRecorder error:', event.error);
                };
                mediaRecorder.onstop = async () => {
                    onReportEvent(EVENT_TRACER.LIVENESS.LivenessFinishCaptureVideo, 'El liveness termino grabación de video con codec: ' + codecSelected).catch()
                    const typeToBlob = { type: codecSelected }
                    const videoBlob = new Blob(chunks, typeToBlob);
                    const base64Video = await blobToBase64(videoBlob)
                    resolve({
                        blob: videoBlob,
                        base64: base64Video
                    })
                };
            } catch (e) {
                console.log('e', e)
                reject(e)
            }
        })
    }
    function resizeBase64(base64, nuevoAncho, nuevoAlto, calidad) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = nuevoAncho;
                canvas.height = nuevoAlto;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, nuevoAncho, nuevoAlto);

                canvas.toBlob(
                    (blob) => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            resolve({
                                blob,
                                base64: reader.result
                            });
                        };
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    },
                    'image/jpeg',
                    calidad
                );
            };
            img.onerror = reject;
            img.src = base64;
        });
    }




    function configUI(rectangleWidth, rectangleHeight) {
        // Mostrar mensaje de error
        if (showError.trim() === 'false') {
            setShowMessage(false);
        }
        configureGuideAdoSize(rectangleWidth, rectangleHeight);
        scanLine.current.style.animationPlayState = 'running';
        configureBackImageDisplay();
        showScreenElements();
    }

    function configureGuideAdoSize(rectangleWidth, rectangleHeight) {
        const scaleWidth = isMobile() ? 0.56 : 1.1;
        const scaleHeight = isMobile() ? 0.56 : 1.0;
        Object.assign(guideAdoRef.current.style, {
            width: `${rectangleWidth * scaleWidth}px`,
            height: `${rectangleHeight * scaleHeight}px`,
        });
    }

    function configureBackImageDisplay() {
        const display = config.current?.showBack ? 'visible' : 'hidden';
        imgBack.current.style.visibility = display;
    }

    function responseToHost(response, status = 'success') {
        hideScreenElements()
        const streamRef = Stream.getInstance(initDevice())

        if (status !== 'timeout') {
            const containerResultImage = document.getElementById('container-result-image-ado')
            // const containerResultVideo = document.getElementById('container-result-video-ado')

            containerRef.current.style.removeProperty('transform')
            containerRef.current.style.removeProperty('-webkit-transform')
            containerRef.current.classList.remove('container-liveness-ado')
            if (videoRef.current) {
                videoRef.current.remove()
            }
            imgResult.current.src = response.photoBase64
            setDisplayElement(containerResultImage, 'block')
            // setDisplayElement(containerResultVideo, 'block')
            setDisplayElement(imgResult.current, 'block')
            // setDisplayElement(videoResult.current, 'block')
            // videoResult.current.src = response.videoBase64
            // videoResult.current.style.maxWidth = '100%'
            document.body.style.overflow = 'scroll'
        }
        streamRef.dropStream()
        stopCamera()
    }

    const handleFlash = (e) => {
        setFlashOn(e.target.checked);
        if (activeFlash === 'false' && platform !== 'android') return
        const message = e.target.checked ? 'brightness-on' : 'brightness-off'
        const messageAndroid = {
            type: 'brightness',
            value: e.target.checked
        }
        if (isMovil) {
            window.ReactNativeWebView.postMessage(message);
            return
        }
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(message);
            return
        }

        if (platform === 'android') {
            window.Brightness.handleEvent(JSON.stringify(messageAndroid));
            return
        }

        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(message)
            return
        }
        if (platform === 'web') {
            window.parent.postMessage(message, '*')
        }
    }
    function responseToHostLoading(data) {
        const payload = {
            type: 'loader',
            step: 'loading',
            data,
        }

        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify(payload));
            return;
        }

        if (platform === 'android') {
            window.ResponseAdo.handleEvent(JSON.stringify(payload));
            return
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify(payload))
            return
        }
        window.parent.postMessage(
            JSON.stringify(payload),
            '*'
        );
    }
    function responseToHostError(response) {
        if (debug === 'true') {
            alert(response)
        }
        onReportEvent(EVENT_TRACER.LIVENESS.LivenessResponseToHost, "EL liveness emitió al host un error").catch()
        if (isMovil) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    type: 'error-intern',
                    step: 'permissionDenied',
                    data: 'permissionDenied',
                    message: response,
                })
            );
            return
        }
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'error-intern',
                step: 'permissionDenied',
                data: 'permissionDenied',
                message: response,
            }));
            return
        }

        if (platform === 'android') {
            window.ResponseAdo.handleEvent(JSON.stringify({
                type: 'error-intern',
                step: 'permissionDenied',
                data: 'permissionDenied',
                message: response,
            }));
            return
        }

        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'error-intern',
                step: 'permissionDenied',
                data: 'permissionDenied',
                message: response,
            }))
            return
        }
        if (platform === 'web') {
            window.parent.postMessage(JSON.stringify({
                type: 'error-intern',
                step: 'permissionDenied',
                data: 'permissionDenied',
                message: response,
            }), '*')
        }
    }
    function goBack() {
        onReportEvent(EVENT_TRACER.LIVENESS.LivenessResponseToHost, "EL liveness emitió al host boton ir atras").catch()
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'success',
                status: 'back',
                data: '',
            }));
            return;
        }

        if (platform === 'android') {
            window.FinishClose.goBack();
            return
        }
        window.parent.postMessage(
            JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }),
            '*'
        );
    }
    function responseToHostReadyCam() {

        if (emitReadyCam === 'true') {

            const message = 'ado-cam-ready'

            if (isMovil) {
                window.ReactNativeWebView.postMessage(message);
                return
            }
            if (platform === 'ios') {
                window.webkit.messageHandlers.messageHandlersName.postMessage(message);
                return
            }
    
            if (platform === 'android') {
                window.ResponseAdo.handleEvent(message);
                return
            }
    
            if (platform === 'react-native') {
                window.ReactNativeWebView.postMessage(message)
                return
            }
            if (platform === 'web') {
                window.parent.postMessage(message, '*')
            }
        }

    }

    async function getConfig() {
        try {
            const result = await fetchConfigurationCDN();
            if (result) {
                applyConfiguration(result);
            } else {
                startCamera('user');
            }
        } catch (e) {
            handleConfigurationError(e);
        }
    }

    async function fetchConfigurationCDN() {
        try {
            const response = await fetch(`https://lnesv3-conf.ado-tech.com/${projectName}/Liveness/config.json`, { method: 'GET' });
            if (!response.ok) throw new Error('Failed to fetch configuration');
            return response.json();
        } catch (error) {
            console.error('Fetching default configuration due to error:', error.message);
            const defaultResponse = await fetch(`https://lnesv3-conf.ado-tech.com/Default/Liveness/config.json`, { method: 'GET' });
            return defaultResponse.json();
        }
    }


    function applyConfiguration(configData) {
        config.current = configData;
        CONFIG = configData; // Assuming CONFIG is a global variable that needs to be set.
        setShowFlash(configData.showFlash);
        // handleCloseIcon(configData);
        handleCameraFlip(configData.typeCamera);
        startCamera(configData.typeCamera);
    }

    function handleCloseIcon(configData) {
        const showClose = configData.showBack || false;
        if (showClose && isMobile()) {
            const closeIcon = configData.cardCapture?.closeIcon;
            const iconHTML = `<img alt="img-back" style="width: 100%" src="${closeIcon?.url}"/>`;
            imgBack.current.insertAdjacentHTML("afterbegin", iconHTML);
            const iconSize = closeIcon?.size || '30px';
            imgBack.current.style.height = iconSize;
            imgBack.current.style.width = iconSize;
        }
    }

    function handleCameraFlip(typeCamera) {
        if (typeCamera === 'environment') {
            videoRef.current.style.transform = 'scaleX(-1)';
        }
    }

    function handleConfigurationError(error) {
        setLoading(false);
        const errorMessage = "Error obtaining project configuration";
        onReportEvent(EVENT_TRACER.LIVENESS.LivenessResponseToHost, errorMessage).catch();
        responseToHostError(errorMessage);
        console.error('error', error);
    }




    useEffectOnce(() => {
        if (projectName) {
            getConfig().catch()
        }
    }, [projectName])


    useEffect(() => {
        const handleOnline = () => {
            console.log('hay internet');
        };

        const handleOffline = () => {
            setMessagesLiveness('Error');
            onReportEvent(EVENT_TRACER.LIVENESS.LivenessResponseToHost, "No hay conexión a internet").catch()
            responseToHost('No hay conexión a internet', 'internet');
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (seconds === TIMEMOUT) {
        // onReportEvent(EVENT_TRACER.LIVENESS.LivenessTimeout, 'El liveness entró en timeout').catch()
        // onReportEvent(EVENT_TRACER.LIVENESS.LivenessResponseToHost, 'Se excedió el tiempo para la captura').catch()
        // responseToHost('Se excedió el tiempo para la captura', 'timeout');
        // stopCamera()
        // clearInterval(timer);
    }
    return {
        errorMessage,
        showMessage,
        showcheck,
        config,
        canvasRef,
        finished,
        messagesLiveness,
        showError,
        loading,
        projectName,
        loadingMetaData,
        emitReadyCam,
        goBack,
        handleFlash,
        flashOn
    }
}
